import React, { createContext, useContext, useState, useEffect } from 'react';

const NavigationContext = createContext();

export const useNavigation = () => {
  const context = useContext(NavigationContext);
  if (!context) {
    throw new Error('useNavigation must be used within NavigationProvider');
  }
  return context;
};

export const NavigationProvider = ({ children }) => {
  const [tabStates, setTabStates] = useState({});

  // Load saved tab states from localStorage on mount
  useEffect(() => {
    try {
      const savedStates = localStorage.getItem('tabNavigationStates');
      if (savedStates) {
        const parsedStates = JSON.parse(savedStates);
        setTabStates(parsedStates);
      }
    } catch (error) {
      console.warn('Could not load tab navigation states:', error);
    }
  }, []);

  // Save tab states to localStorage whenever they change
  useEffect(() => {
    try {
      localStorage.setItem('tabNavigationStates', JSON.stringify(tabStates));
    } catch (error) {
      console.warn('Could not save tab navigation states:', error);
    }
  }, [tabStates]);

  const saveTabState = (tabName, state) => {
    setTabStates(prev => ({
      ...prev,
      [tabName]: {
        ...prev[tabName],
        ...state,
        lastVisited: Date.now()
      }
    }));
  };

  const getTabState = (tabName) => {
    return tabStates[tabName] || {};
  };

  const clearTabState = (tabName) => {
    setTabStates(prev => {
      const newStates = { ...prev };
      delete newStates[tabName];
      return newStates;
    });
  };

  const clearAllTabStates = () => {
    setTabStates({});
    localStorage.removeItem('tabNavigationStates');
  };

  return (
    <NavigationContext.Provider value={{
      tabStates,
      saveTabState,
      getTabState,
      clearTabState,
      clearAllTabStates
    }}>
      {children}
    </NavigationContext.Provider>
  );
};